import styled from 'styled-components';

export const StyledReasonsSection = styled.section`
    display: flex;
    flex-direction: column;
    margin: 0 15px 50px 15px;
    text-align: center;

    & > div {
        display: flex;
        flex-direction: column;
        flex-wrap: wrap;
        align-items: center;
        align-content: center;
        overflow: visible;
    }

    & > a {
        display: none;
    }

    & p {
        font-weight: 500;
        font-size: 16px;
        line-height: 20.4px;
        margin: 10px 0 30px 0;
    }

    @media screen and (min-width: 577px) {
        max-width: 925px;
        margin: 0 0 80px 0;

        & > a {
            display: block;
            margin-top: 15px;
            width: auto;
        }

        & div {
            height: 680px;
        }

        & p {
            font-weight: 500;
            font-size: 20px;
            line-height: 25.5px;
            margin: 20px 0 50px 0;
        }
    }
`;

export const StyledReasonsCard = styled.article`
    box-sizing: border-box;
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    padding: 20px 15px 15px 15px;
    border: none;
    border-radius: 20px;
    background-repeat: no-repeat;
    & > h3 {
        margin-top: 120px;
        font-weight: 700;
        font-size: 20px;
        line-height: 25.5px;
        color: #ffffff;
    }

    p,
    span {
        color: #ffffff99;
    }

    p {
        margin: 10px 0 0 0;
        font-size: 16px;
        font-weight: 500;
        line-height: 20.4px;
    }

    &:first-child {
        justify-content: flex-start;
    }

    &:not(:last-child) {
        margin-bottom: 15px;
    }

    @media screen and (min-width: 577px) {
        margin: 15px;
        padding: 30px 15px 20px 15px;
        width: 445px;
        border-radius: 30px;

        & h3 {
            margin-top: unset;
            font-size: 30px;
            line-height: 38.25px;
        }

        p,
        span {
            margin: 15px 0 0 0;
            color: #ffffff;
            font-size: 20px;
            font-weight: 300;
            line-height: 25.5px;
        }

        &:first-child {
            flex-grow: 2;
            height: 100%;
        }
    }

    ${({ $specificCss }) => $specificCss ?? ''};
`;
